import { create } from "zustand";
import { AccountDetailsType } from "@/services/type";

interface AccountState {
  accountDetails: AccountDetailsType;
  isAccountResolved: boolean;
  setAccountDetails: (details: AccountDetailsType) => void;
  setIsAccountResolved: (isResolved: boolean) => void;
  updateAccountDetails: (updates: Partial<AccountDetailsType>) => void;
}

export const initialAccountDetailsState: AccountDetailsType = {};

export const useAccountStore = create<AccountState>((set) => ({
  accountDetails: initialAccountDetailsState,
  isAccountResolved: false,
  setAccountDetails: (details: AccountDetailsType) =>
    set({ accountDetails: details, isAccountResolved: true }),
  setIsAccountResolved: (isResolved: boolean) =>
    set({ isAccountResolved: isResolved }),
  updateAccountDetails: (updates: Partial<AccountDetailsType>) =>
    set((state) => ({
      accountDetails: { ...state.accountDetails, ...updates },
    })),
}));
